import validate from 'validate.js/validate.js'
import moment from 'moment'

validate.extend(validate.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse: function (value, options) {
    return +moment.utc(value)
  },
  // Input is a unix timestamp
  format: function (value, options) {
    const format = options.dateOnly
      ? moment.localeData().longDateFormat('L')
      : `${moment.localeData().longDateFormat('L')} ${moment.localeData().longDateFormat('LTS')}`
    return moment.utc(value).format(format)
  },
})

export { validate }
